/**
 * Combien de dossiers partent avec cet expéditeur. Les affectations de
 * domaine et par défaut ne comptent pas : elles ne désignent pas un dossier.
 */
export function compterDossiersAffectes(
  configurations: { senderUuid: string; folderUuid?: string | null }[],
  senderUuid: string,
): number {
  // Une réponse inattendue (enveloppe, erreur) ne doit jamais casser l'écran.
  if (!Array.isArray(configurations)) return 0;
  const dossiers = new Set(
    configurations
      .filter(c => c.senderUuid === senderUuid && c.folderUuid)
      .map(c => c.folderUuid as string),
  );
  return dossiers.size;
}
